import { Link, useParams } from 'react-router';
import { getAdminCatalogCategoryEditPath, getAdminCatalogCategoryDetailPath } from '../adminRoutes';
import { CatalogEntityHeader } from './CatalogEntityHeader';
import { CatalogRequestState } from './CatalogRequestState';
import { CatalogSaveNotice } from './CatalogSaveNotice';
import { CatalogCategoryImage } from './CatalogCategoryImage';
import { CatalogChildCategories } from './CatalogChildCategories';
import { CatalogCategoryProducts } from './CatalogCategoryProducts';
import { useCatalogCategoryQuery } from './useCatalogCategoryEditor';
import { catalogDate } from './catalogDisplay';
import './catalogEditor.css';

export function CatalogCategoryDetailPage() {
  const params = useParams();
  const categoryId = Number(params.categoryId);
  const isValidId = Number.isSafeInteger(categoryId) && categoryId > 0;
  const query = useCatalogCategoryQuery(isValidId ? categoryId : undefined);
  const category = query.data;
  const error = !isValidId ? 'Некорректный адрес страницы.' : query.error?.message;
  const editPath = getAdminCatalogCategoryEditPath(categoryId);
  const parentPath = category?.category_parent_id ? getAdminCatalogCategoryDetailPath(category.category_parent_id) : null;
  return (
    <section className="admin-page catalog-workspace">
      <CatalogEntityHeader kind="categories" title={category?.category_name ?? 'Категория'} subtitle="Категория каталога" actions={category ? <Link className="catalog-button catalog-button_primary" to={editPath}>Редактировать категорию</Link> : null} />
      <CatalogSaveNotice />
      {category && !error ? <>
        <section className="catalog-category-overview" aria-label="Сведения о категории">
          <div><h2>О категории</h2><p className="catalog-description-copy">{category.category_description || 'Описание ещё не заполнено.'}</p></div>
          <dl className="catalog-facts"><div><dt>Родительская категория</dt><dd>{parentPath ? <Link to={parentPath}>{category.category_parent_name || 'Открыть категорию'}</Link> : 'Верхний уровень'}</dd></div><div><dt>Порядок сортировки</dt><dd>{category.category_order}</dd></div><div><dt>Обновлена</dt><dd>{catalogDate(category.category_updated_at)}</dd></div></dl>
        </section>
        <CatalogCategoryImage key={`image-${categoryId}`} categoryId={categoryId} name={category.category_name} />
        <CatalogChildCategories key={`children-${categoryId}`} categoryId={categoryId} />
        <CatalogCategoryProducts key={`products-${categoryId}`} categoryId={categoryId} />
      </> : <CatalogRequestState error={error} onRetry={() => { void query.refetch(); }} />}
    </section>
  );
}
